import type { AutoIntegrationListItem } from "@msuite/utils/types";
import type { Row } from "@msuite/ui/table";

export function enableRowSelection<T>(row: Row<AutoIntegrationListItem<T>>) {
	if (row.original.state === "both") return false;
	if (!row.original.externalMisc) return false;
	return true;
}
